module.exports = __webpack_public_path__ + "static/media/icon woman.34c70167.png";